export const homeRenovationConversionContent = {
  title: 'Chegou a hora de transformar sua casa',
  firstParagraph: 'Sua reforma não precisa ficar para depois.'
}
